import { render, staticRenderFns } from "./PricingTariffs.vue?vue&type=template&id=7370a04f"
import script from "./PricingTariffs.vue?vue&type=script&lang=js"
export * from "./PricingTariffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports